import { Link } from 'react-router-dom';
import Avatar from '../../../../components/Avatar/Avatar';
import Footer from '../../../../partials/Footer/Footer';
import Header from '../../../../partials/Header/Header';
import './DashboardPage.css';
import { useAuth } from '../../../../contexts/AuthContext';
import HomeContent from './partials/home/home-content';
import React, { useEffect, useState } from 'react';
import CourseContent from './partials/courses/course-content';

const DashboardPage = () => {
    const { user, logout } = useAuth();
    const [openContent, setOpenContent] = useState<string>('home');
    const [content, setContent] = useState<React.ReactNode>(<HomeContent />);

    const handleLogout = () => {
        logout();
    };

    const handleContentChange = (contentType: string) => {
        setOpenContent(contentType);
    };

    useEffect(() => {
        const renderContent = () => {
            switch(openContent) {
                case 'home':
                    setContent(<HomeContent />);
                    break;
                case 'courses':
                    setContent(<CourseContent />);
                    break;
                // Adicione outros cases conforme necessário
                default:
                    setContent(<HomeContent />);
            }
        }

        renderContent();
    }, [openContent]);

    return (
        <div id="dashboard">
            <Header />

            <main className="container">
                <div className="sidebar-left">
                    <div className="user-info">
                        <div className="user">
                            <Avatar />
                            <h4>{user?.fullName}</h4>
                        </div>

                        <div className="links">
                            <button
                                className={`link ${openContent === 'home' ? 'active' : ''}`}
                                onClick={() => handleContentChange('home')}
                            >
                                <i className="fa-solid fa-user"></i>
                                Home
                            </button>

                            <button 
                                className={`link ${openContent === 'courses' ? 'active' : ''}`}
                                onClick={() => handleContentChange('courses')}
                            >
                                <i className="fa-solid fa-book"></i>
                                Courses
                            </button>

                            <button 
                                className={`link ${openContent === 'certificates' ? 'active' : ''}`}
                                onClick={() => handleContentChange('certificates')}
                            >
                                <i className="fa-solid fa-certificate"></i>
                                Certificates
                            </button>

                            <button 
                                className={`link ${openContent === 'calendar' ? 'active' : ''}`}
                                onClick={() => handleContentChange('calendar')}
                            >
                                <i className="fa-solid fa-calendar"></i>
                                Calendar
                            </button>

                            <button 
                                className={`link ${openContent === 'messages' ? 'active' : ''}`}
                                onClick={() => handleContentChange('messages')}
                            >
                                <i className="fa-solid fa-message"></i>
                                Messages
                            </button>

                            <button className="link" onClick={handleLogout}>
                                <i className="fa-solid fa-right-from-bracket"></i>
                                Logout
                            </button>
                        </div>
                    </div>

                    <div className="settings">
                        <Link to="/settings" className="link">
                            <i className="fa-solid fa-gear"></i>
                            Settings
                        </Link>
                    </div>
                </div>

                <div className="content">
                    {content}
                </div>
            </main>

            <Footer />
        </div>
    )
}

export default DashboardPage; 